module.exports = __webpack_public_path__ + "static/media/journal1.930687d6.png";